import React, { useState } from 'react';
import video from '../img/Auto tuv.mp4';
import './css/Video.css';

const Video: React.FC = () => {
    const [isMinimized, setIsMinimized] = useState(false);

    const toggleMinimize = () => {
        setIsMinimized(prev => !prev);
    };

    return (
        <section className={`sticky-video-section ${isMinimized ? 'minimized' : ''}`}>
            <div className="sticky-video-container">
                <div className="sticky-video-wrapper">
                    <div className="video-header" onClick={toggleMinimize} style={{ cursor: 'pointer' }}>
                        <h3 className="sticky-video-title">БИДНИЙ ТАНИЛЦУУЛГА</h3>
                        <button
                            className="minimize-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleMinimize();
                            }}
                            aria-label={isMinimized ? 'Expand video' : 'Minimize video'}
                        >
                            {isMinimized ? '+' : '−'}
                        </button>
                    </div>
                    {!isMinimized && (
                        <video
                            controls
                            className="sticky-video"
                        >
                            <source src={video} type="video/mp4" />
                            Таны хөтөч видео тоглуулах боломжгүй байна.
                        </video>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Video;